var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21V6H3a1 1 0 00-1 1v14m5 0H1m6 0h10M7 21V4.04C7 3.466 7.448 3 8 3h8c.552 0 1 .466 1 1.04V21m5 0V7a1 1 0 00-1-1h-4v15m0 0h6M9.5 18h5M10 15h4m-4-3h4m-9 1.5h2M5 17h2m-2-7h2m10 3.5h2M17 17h2m-2-7h2m-8.5-2.5h3M12 9V6m-1.5 12h3v3h-3v-3z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgHospital;